import React from 'react';
export function NotTheaterSection() {
  return <section className="py-20 px-6 md:px-12 lg:px-24 bg-[#F8F8F8] overflow-hidden" data-id="element-1093">
      <div className="max-w-7xl mx-auto" data-id="element-1094">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1fr] gap-16 items-start" data-id="element-1095">
          {/* LEFT: Narrative + closing bar */}
          <div className="flex flex-col gap-8" data-id="element-1096">
            <div data-id="element-1097">
              <span className="text-xs font-bold tracking-[0.3em] uppercase text-gray-400 font-sans block mb-5" data-id="element-1098">
                The Distinction That Matters
              </span>
              <h2 className="text-4xl md:text-5xl font-bold font-['Syne'] leading-[0.95] tracking-tight text-black mb-6" data-id="element-1099">
                Not theater.
                <br data-id="element-1100" />
                <span className="text-[#0066FF]" data-id="element-1101">Architecture.</span>
              </h2>
            </div>

            <p className="text-lg text-gray-700 leading-relaxed font-light" data-id="element-1102">
              Every AI platform asks the model to perform.{' '}
              <em className="text-gray-500 not-italic" data-id="element-1103">
                Act as if you're our best compliance officer. Write like our
                brand. Respond like a senior advisor.
              </em>
            </p>

            <p className="text-base text-gray-600 leading-relaxed" data-id="element-1104">
              This is character instruction. The model interprets it through
              training data — press coverage, job descriptions, public
              mythology. The output might feel right.{' '}
              <strong className="text-black font-semibold" data-id="element-1105">
                But you have no idea what assumptions it made, and you cannot
                audit them.
              </strong>
            </p>

            <p className="text-base text-gray-600 leading-relaxed" data-id="element-1106">
              Synthia doesn't ask the model to perform. It tells the model
              exactly how to behave. Every directive is atomic. Every directive
              is traceable. Every directive fires before the model reasons — not
              as a suggestion, but as a governed instruction.
            </p>
          </div>

          {/* RIGHT: Contrast boxes stacked */}
          <div className="flex flex-col gap-4" data-id="element-1107">
            {/* Theater (wrong) */}
            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm" data-id="element-1108">
              <div className="flex items-center gap-2 mb-4" data-id="element-1109">
                <div className="w-2 h-2 rounded-full bg-red-500 flex-shrink-0" data-id="element-1110"></div>
                <span className="text-xs font-bold tracking-widest uppercase text-red-500 font-sans" data-id="element-1111">
                  Theatrical Instruction
                </span>
              </div>
              <div className="space-y-2" data-id="element-1112">
                <div className="px-4 py-3 border border-red-100 rounded-lg bg-red-50" data-id="element-1113">
                  <p className="text-gray-500 text-xs font-mono leading-relaxed" data-id="element-1114">
                    "Act like your best compliance officer."
                  </p>
                </div>
                <div className="px-4 py-3 border border-red-100 rounded-lg bg-red-50" data-id="element-1115">
                  <p className="text-gray-500 text-xs font-mono leading-relaxed" data-id="element-1116">
                    "Write like our brand."
                  </p>
                </div>
                <div className="px-4 py-3 border border-red-100 rounded-lg bg-red-50" data-id="element-1117">
                  <p className="text-gray-500 text-xs font-mono leading-relaxed" data-id="element-1118">
                    "Respond like a senior advisor."
                  </p>
                </div>
              </div>
            </div>

            {/* Governed (right) */}
            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm" data-id="element-1119">
              <div className="flex items-center gap-2 mb-4" data-id="element-1120">
                <div className="w-2 h-2 rounded-full bg-[#0066FF] flex-shrink-0" data-id="element-1121"></div>
                <span className="text-xs font-bold tracking-widest uppercase text-[#0066FF] font-sans" data-id="element-1122">
                  Governed Instruction
                </span>
              </div>
              <div className="space-y-2" data-id="element-1123">
                <div className="px-4 py-3 border border-blue-100 rounded-lg bg-blue-50" data-id="element-1124">
                  <p className="text-gray-700 text-xs font-mono leading-relaxed" data-id="element-1125">
                    "Never summarize regulatory risk without citing the
                    applicable CFR section."
                  </p>
                </div>
                <div className="px-4 py-3 border border-blue-100 rounded-lg bg-blue-50" data-id="element-1126">
                  <p className="text-gray-700 text-xs font-mono leading-relaxed" data-id="element-1127">
                    "Short declarative sentences. Active voice. No superlatives.
                    Describe outcomes, not features."
                  </p>
                </div>
                <div className="px-4 py-3 border border-blue-100 rounded-lg bg-blue-50" data-id="element-1128">
                  <p className="text-gray-700 text-xs font-mono leading-relaxed" data-id="element-1129">
                    "Escalate to human review when confidence in regulatory
                    interpretation falls below threshold."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Closing line */}
        <p className="text-center text-lg text-gray-500 font-sans mt-10" data-id="element-1130">
          The difference is{' '}
          <strong className="text-black" data-id="element-1131">auditability.</strong>
          <span className="mx-3 text-gray-300" data-id="element-1132">·</span>
          The difference is <strong className="text-black" data-id="element-1133">ownership.</strong>
          <span className="mx-3 text-gray-300" data-id="element-1134">·</span>
          The difference is <strong className="text-black" data-id="element-1135">control.</strong>
        </p>
      </div>
    </section>;
}